export const PURCHASE_ICON_PATH = '/public/assets/icons/Purchase Icon.svg';
export const TELEPHONE_ICON_PATH = '/public/assets/icons/Telephone Icon.svg';
export const FABRICATION_ICON_PATH = '/public/assets/icons/Fabrication Icon.svg';
export const VERIFICATION_ICON_PATH = '/public/assets/icons/Verification Icon.svg';
export const INSTALL_ICON_PATH = '/public/assets/icons/Install Icon.svg';
export const DELIVERY_ICON_PATH = '/public/assets/icons/Delivery Icon.svg';
